export default defineAppConfig({
  ui: {
    primary: "cyan",
  },
});
